import { LogManager } from '../../LogManager'
import type { LoginAnalyticsSink } from './login-analytics'

export const logManagerSink: LoginAnalyticsSink = ({ name, data, timestamp }) => {
	LogManager.info({
		...data,
		message: `[login-analytics] ${name}`,
		_loginEvent: name,
		_loginTimestamp: timestamp,
	})
}

export const fullStorySink: LoginAnalyticsSink = ({ name, data }) => {
	if (typeof window !== 'undefined') {
		const w = window as unknown as Record<string, unknown>
		const fs = w.FS as { event?: (name: string, data: Record<string, unknown>) => void } | undefined
		fs?.event?.(name, data)
	}
}
